var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ActionTypes } from './actions';
export var initialState = {
    data: [],
    isLoading: false,
    error: null,
    search: null,
};
export var localities = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes.LOAD_LOCALITIES:
            return __assign(__assign({}, state), { isLoading: true, error: null, search: action.payload.search });
        case ActionTypes.LOAD_LOCALITIES_SUCCESS:
            return __assign(__assign({}, state), { isLoading: false, data: action.payload.localities });
        case ActionTypes.LOAD_LOCALITIES_FAILURE:
            return __assign(__assign({}, state), { error: action.payload.error });
        case ActionTypes.REMOVE_LOCALITIES_ERROR:
            return __assign(__assign({}, state), { error: null });
        default:
            return state;
    }
};
